import React from 'react';
import Tabs from '../../components/tabs/HomePageTabs.jsx';
import KnowQuestHomeLogo from '../../assets/images/logo.png';
import OldSearch from '../../components/OldSearch.jsx';
import Searchbar from '../../components/Searchbar.jsx';

const Hometwo = () => {
  return (
    <div className="">
      <div className="grid gap-10 font-montserrat sm:grid-cols-1">
        {/* Centered Logo */}
        <div className="flex justify-center items-center py-2">
          <img
            src={KnowQuestHomeLogo}
            alt="KnowQuest Home Logo"
            className="w-20 "
          />
        </div>

        {/* Announcements Section */}
        {/* <div className='grid place-items-center '>
          <Announcements/>
        </div> */}

        <div className="grid place-items-center p-4  gap-4">
          <div className="font-bold text-white text-4xl md:text-6xl text-center">
            <span className="text-secondary">Trusted</span> Reviews made Simple
          </div>
          <Searchbar />
          {/* <OldSearch/> */}
          <a href="/advance-search/movies">
            {/* <Button type="button" variant="button">
              Advanced Search
            </Button> */}
          </a>
        </div>

        <div className="text-center text-white grid gap-4">
          <div className="text-2xl md:text-4xl font-medium">
            Discover Trending
          </div>
          <div className="text-faded text-sm md:text-xl font-hind">
            Explore a mix of trending reviews from each category below
          </div>
        </div>
      </div>
      <Tabs />
    </div>
  );
};

export default Hometwo;
